const { createContext } = require("react");

const UnallotedSharesContext = createContext({});

export default UnallotedSharesContext;
